<template>
    <section>
        <div class="pro_section3" style="display: flex; position: relative; margin-bottom: 360px;">
            <div class="con_wrap" style="display: flex; flex-direction: column;">
                <div style="position: relative; display: flex; flex-direction: column; margin-bottom: 200px;">
                    <p style="font-size: 25px; font-weight: 700; color: white; text-align: left; color: #000000; margin-bottom: 22px;">
                        Mission & Vision
                    </p>
                    <div style="display: flex; flex-direction: column; z-index: 1">
                        <div data-aos="fade-left"
                                data-aos-delay="100"
                                data-aos-once="true"
                                data-aos-duration="600"
                                data-aos-easing="ease-in-out"  style="display: flex; justify-content: space-between; margin-bottom: 70px;">
                            <p style="font-size: 50px; font-weight: 700; color: white; text-align: center; color: #000000;">모두의 꿈</p>
                            <p style="font-size: 26px; font-weight: 400; line-height: 1.5;">
                                우리의 서비스를 통해 학생들이 공부에 집중할 수 있는 환경<br>
                                이 조성되고 성공적인 입시를 해나갈 수 있도록, 모두가 꿈을<br>
                                이룰 때까지 서비스를 만들어 나갑니다.
                            </p>
                        </div>
                        <div data-aos="fade-left"
                                data-aos-delay="100"
                                data-aos-once="true"
                                data-aos-duration="600"
                                data-aos-easing="ease-in-out"  style="display: flex; justify-content: space-between; margin-bottom: 20px;">
                            <p style="font-size: 50px; font-weight: 700; color: white; text-align: center; color: #000000;">미래를 채울 때까지</p>
                            <p style="font-size: 26px; font-weight: 400; line-height: 1.5;">
                                사용자가 원하는 미래를 채울 때까지 우리는 정확하고 다양한<br>
                                서비스를 제공하고, 다양한 컨텐츠를 통해서 차별화된 서비스<br>
                                로 사용자에게 인정받는 플랫폼이 되겠습니다.
                            </p>
                        </div>
                    </div>
                </div>
                <p data-aos="fade-down"
                    data-aos-delay="100"
                    data-aos-once="true"
                    data-aos-duration="600"
                    data-aos-easing="ease-in-out" 
                    data-aos-anchor-placement="center-bottom" style="font-size: 25px; font-weight: 700; color: white; text-align: center; color: #1C9CD3; margin-bottom: 74px;">
                    우리는 끊임없이 추구합니다
                </p>
                <div ref="circle" style="position: relative; display: flex; justify-content: center; height: 300px">
                    <div v-for="(item, index) in pursuit" :key="index" :style="{zIndex: 3 - index, left: moveCircle ? ((index != 0) ? ((index + 1) * 20) + (index * 10) + '%' : '20%') : '20%', opacity: moveCircle ? 1 : ((index != 0) ? 0 : 1)}" style="position: absolute; display: flex; justify-content: center; align-items: center; width: 300px; height: 300px; border-radius: 100%; transform: translateX(-50%); border: 1px solid #1C9CD3; color: #1C9CD3; background: white; font-size: 25px; font-weight: 500; transition: all 0.5s ease;">{{item}}</div>
                </div>
            </div>
        </div>
    </section>
</template>
<script>
import { ChevronDownIcon } from 'vue-feather-icons'
export default {
    props: ['data'],
    components: {
        ChevronDownIcon,
    },
    data() {
        return {
            moveCircle: false,
            pursuit: [
                '정확함',
                '다양함',
                '신뢰감',
            ],

        }
    },
    computed: {
        scrollY() {
            return this.$store.state.scrollY
        },
        circle() {
            return this.$refs.circle
        },
    },
    methods: {
        handleScroll(e) {
            console.log(this.circle.getBoundingClientRect().top)
            if(this.circle.getBoundingClientRect().top < (window.innerHeight - 200)) {
                if(e.deltaY > 0) {
                    this.moveCircle = true
                } 
                // else {
                //     this.moveCircle = false
                //     if(this.circle.offsetHeight < this.circle.getBoundingClientRect().top) {
                //         this.moveCircle = false
                //     }
                // }
            } else {
                if(e.deltaY < 0) {
                    this.moveCircle = false
                }
            }

        }
    },
    created() {
        document.addEventListener('wheel', this.handleScroll)
    },
    beforeDestroy() {
        document.removeEventListener('wheel', this.handleScroll)
    },    
}
</script>